import type { meta } from './meta';
import type { ConnectionTypeOption, SourceId } from './sources';

type HeaderSettingsType<T extends SourceId = SourceId> = {
  hasHeader: boolean;
  mobileBreakpoint: number;
  connectionTypes: ConnectionTypeOption<T>['value'][];
};

export const HEADER_CONFIG: Record<typeof meta.alias, HeaderSettingsType> = {
  'tiktok-feed': {
    hasHeader: true,
    mobileBreakpoint: 500,
    connectionTypes: ['tiktokProfile']
  },
  'rss-feed': {
    hasHeader: false,
    mobileBreakpoint: 0,
    connectionTypes: []
  },
  'linkedin-feed': {
    hasHeader: true,
    mobileBreakpoint: 440,
    connectionTypes: ['linkedinSource']
  },
  'social-feed': {
    hasHeader: false,
    mobileBreakpoint: 0,
    connectionTypes: []
  },
  'tumblr-feed': {
    hasHeader: false,
    mobileBreakpoint: 0,
    connectionTypes: []
  },
  'vk-feed': {
    hasHeader: false,
    mobileBreakpoint: 0,
    connectionTypes: []
  }
};
